import clearLocalStorage from './clearLocalStorage'

const redirectToURL = (redirectURL) => {
  clearLocalStorage()
  window.location.assign(redirectURL)
}

export default redirectToURL
